import { IImgSrcSets } from './prepareSrcSets';

type TSrcSource = { media: string; srcset: string } | { srcset: string; media?: undefined };

export const mediaQueryforX2Images = '(-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)';

export function createSrcSources(imgObject?: IImgSrcSets): TSrcSource[] | undefined {
  if (!imgObject) {
    return undefined;
  }

  return [
    {
      media: mediaQueryforX2Images,
      srcset: imgObject.x2,
    },

    { srcset: imgObject.x1 },
  ];
}
